var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.225 3.96a1.412 1.412 0 0 0-2.45 0L2.206 18.54c-.57.972.115 2.208 1.226 2.208h17.138c1.11 0 1.797-1.237 1.225-2.208L13.225 3.96Zm-1.227 4.292a1.13 1.13 0 0 1 1.125 1.243l-.438 4.383a.69.69 0 0 1-1.375 0l-.437-4.383a1.13 1.13 0 0 1 1.125-1.243ZM12 15.75a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Z"
  })));
};
export default SvgWarning;